import type { SvgProps } from '@/types/svgs/svg-types';

const SiteWideJackpotToggleOff = ({ lineColor }: SvgProps) => (
    <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="0.75"
            y="1.6499"
            width="23.52"
            height="15.4"
            rx="7.7"
            stroke="url(#paint0_linear_10538_76289)"
            strokeWidth="1.5"
        />
        <path
            d="M8.44967 14.3901C11.2332 14.3901 13.4897 12.1336 13.4897 9.35006C13.4897 6.56654 11.2332 4.31006 8.44967 4.31006C5.66615 4.31006 3.40967 6.56654 3.40967 9.35006C3.40967 12.1336 5.66615 14.3901 8.44967 14.3901Z"
            fill="url(#paint1_linear_10538_76289)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_10538_76289"
                x1="-5.35613"
                y1="0.899902"
                x2="20.3119"
                y2="27.5084"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
            <linearGradient
                id="paint1_linear_10538_76289"
                x1="1.2518"
                y1="4.31006"
                x2="15.6475"
                y2="14.3901"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
        </defs>
    </svg>
);

export default SiteWideJackpotToggleOff;
